const API_BASE = String(import.meta?.env?.VITE_API_BASE_URL || "").replace(/\/+$/, "");

function buildUrl(path) {
  const p = String(path || "");
  if (!p.startsWith("/")) return `${API_BASE}/${p}`;
  return `${API_BASE}${p}`;
}

function readToken() {
  try {
    return (
      localStorage.getItem("pohrebka_token") ||
      localStorage.getItem("token") ||
      localStorage.getItem("authToken") ||
      localStorage.getItem("accessToken") ||
      ""
    );
  } catch {
    return "";
  }
}

async function apiFetch(path, options = {}) {
  const token = readToken();

  const headers = {
    Accept: "application/json",
    ...(options.headers || {}),
  };

  if (token) headers.Authorization = `Bearer ${token}`;
  if (options.body && !headers["Content-Type"]) headers["Content-Type"] = "application/json";

  const res = await fetch(buildUrl(path), {
    ...options,
    headers,
  });

  const text = await res.text();
  let data = null;

  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = text;
  }

  if (!res.ok) {
    const msg =
      (data && typeof data === "object" && (data.error || data.message)) ||
      `HTTP ${res.status}`;
    throw new Error(msg);
  }

  return data;
}

function unwrapOrderPayload(payload) {
  if (!payload) return {};
  if (payload.data && typeof payload.data === "object") return unwrapOrderPayload(payload.data);
  if (payload.item && typeof payload.item === "object") return unwrapOrderPayload(payload.item);
  if (payload.order && typeof payload.order === "object") return unwrapOrderPayload(payload.order);
  if (payload.formData && typeof payload.formData === "object") return unwrapOrderPayload(payload.formData);
  return payload;
}

export async function fetchOrdersList() {
  const res = await apiFetch("/api/pohrebka2/orders", { method: "GET" });
  if (Array.isArray(res)) return res;
  if (Array.isArray(res?.data)) return res.data;
  if (Array.isArray(res?.items)) return res.items;
  if (Array.isArray(res?.list)) return res.list;
  return [];
}

export async function fetchOrderById(id) {
  const zid = String(id || "").trim();
  if (!zid) throw new Error("Chybí ID zakázky");

  const res = await apiFetch(`/api/pohrebka2/orders/${encodeURIComponent(zid)}`, {
    method: "GET",
  });

  return unwrapOrderPayload(res);
}

export async function createOrder(order) {
  const res = await apiFetch("/api/pohrebka2/orders", {
    method: "POST",
    body: JSON.stringify({
      formData: order || {},
      __explicit: true,
      __create: true,
    }),
  });

  return res;
}

export async function updateOrder(id, order) {
  const zid = String(id || "").trim();
  if (!zid) throw new Error("Chybí ID zakázky");

  const res = await apiFetch("/api/pohrebka2/orders", {
    method: "POST",
    body: JSON.stringify({
      id: zid,
      formData: order || {},
      __explicit: true,
    }),
  });

  return res;
}

export function resolveSavedOrderId(payload) {
  return String(
    payload?.meta?.id ||
      payload?.id ||
      payload?.data?.id ||
      payload?.orderId ||
      payload?.zakazkaId ||
      ""
  ).trim();
}
